
define('text!TescoMobile_Checkout/template/monthly-payment/total.html',[],function () { return '<div class="monthly-payment-total-amount"><span data-bind="html: monthlyTotal"></span></div>';});

